import { Navigate } from "react-router-dom"
import { useAuth } from "@/hooks/useAuth"
import { LoadingLogo } from "@/components/ui/LoadingLogo"
import HomePage from "./young/HomePage"

export default function Home() {
   const { user, isLoading } = useAuth()

   if (isLoading) {
      return <LoadingLogo />
   }

   if (user?.role === "young") {
      return <HomePage />
   }

   if (user?.role === "admin") {
      return <Navigate to="/admin/faire-l-appel" replace />
   }

   return <Navigate to="/connexion" replace />
}
